import { ProductType } from '@chegg/commerce-utils';
var productType = ProductType.BUNDLE;

/**
 * Gets the select product data needed to update the cart when a multi month csp product is selected
 */
var getSelectProductVariationData = function getSelectProductVariationData(_ref) {
  var _ref$variation = _ref.variation,
    catalogItemId = _ref$variation.catalogItemId,
    pricingLogId = _ref$variation.pricingLogId,
    billingPeriod = _ref$variation.billingPeriod,
    cspProduct = _ref.cspProduct,
    orderSummary = _ref.orderSummary;
  return {
    productType: productType,
    orderSummaryContent: orderSummary,
    taxInfo: cspProduct.taxInfo,
    itemData: [{
      catalogItemId: catalogItemId,
      productType: productType,
      pricingId: pricingLogId,
      catalogItemSource: 'NETSUITE',
      quantity: 1,
      annotation: cspProduct.eligibility.annotation,
      replace: true
    }],
    billingPeriod: billingPeriod
  };
};
export default getSelectProductVariationData;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/getSelectProductVariationData.js
// module id = 4710
// module chunks = 11